'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function SyncCenterPage() {
  const router = useRouter();
  useEffect(() => {
    router.replace('/sync-center/dingtalk');
  }, [router]);
  return null;
}
